import type { Tool } from '@/types/content'

/**
 * The stack shown in the "My Expert area" grid.
 *
 * Nine marks across the three domains: the application (React, GraphQL,
 * PostgreSQL), the infrastructure it runs on (Linux, Docker, AWS, Cisco) and
 * the design it wears (Figma, Adobe). Nine fills the three-column grid
 * exactly, so no tile is left hanging on a short last row.
 *
 * The AWS and Adobe marks come from SVG Repo rather than Simple Icons,
 * which carries neither any more — both were removed at the trademark
 * holders' request. See `brandPaths.ts`.
 */
export const tools: readonly Tool[] = [
  { id: 'react', name: 'React', icon: 'react', href: 'https://react.dev/' },
  { id: 'graphql', name: 'GraphQL', icon: 'graphql', href: 'https://graphql.org/' },
  { id: 'linux', name: 'Linux', icon: 'linux', href: 'https://www.kernel.org/' },
  { id: 'postgresql', name: 'PostgreSQL', icon: 'postgresql', href: 'https://www.postgresql.org/' },
  { id: 'docker', name: 'Docker', icon: 'docker', href: 'https://www.docker.com/' },
  { id: 'aws', name: 'AWS', icon: 'amazonwebservices', href: 'https://aws.amazon.com/' },
  { id: 'cisco', name: 'Cisco', icon: 'cisco', href: 'https://www.cisco.com/' },
  { id: 'figma', name: 'Figma', icon: 'figma', href: 'https://www.figma.com/' },
  { id: 'adobe', name: 'Adobe', icon: 'adobecreativecloud', href: 'https://www.adobe.com/creativecloud.html' },
]

/** Disciplines cycled through the home-page marquee. */
export const expertise: readonly string[] = [
  'UI/UX Design',
  'Full-Stack Development',
  'Cloud & DevOps',
  'Brand Design',
  'Networking',
  'Mobile Apps',
]

/** Statement paired with the expertise marquee. */
export const expertiseStatement =
  'I work across the whole delivery chain: brand and interface design in Figma, the application in React and Node, and the cloud infrastructure and pipelines that run it. That range means fewer handovers and a product that stays coherent from the first sketch to production.'
